module.exports = __webpack_public_path__ + "img/fafa.955e04f0.png";